// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../fonts/stylesheet.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
    margin: 0;
    height: 100%;
    color: #333;
    background-color: #fff;
    -webkit-font-smoothing: antialiased;
    font-family: 'Gill Sans' !important;
    font-weight: 500 !important;
    line-height: 1.5 !important;
    overflow-x: hidden !important;
}
/* .slick-slider {
    overflow: hidden !important;
} */
.header .navbar {
    padding: 0;
    height: 100px;
}
/* .container-fluid {
    padding-right: 60px;
    padding-left: 60px;
} */
.MuiButton-root {
    line-height: 22px!important;
}
.MuiInput-input {
    font-weight: 500!important;
}
.MuiInput-root {
    padding-bottom: 15px!important;
}
.MuiInputLabel-shrink {
    transform: unset!important;
    transform-origin: unset!important;
}
label + .MuiInput-formControl {
    margin-top: 0px!important;
}
.MuiInputLabel-formControl {
    transform: unset!important;
}
.MuiInputLabel-root {
    transform-origin:unset;
    top: 0px !important;
}
.slick-next {
    right: -25px!important;
    
  }
@media (min-width: 1200px) {
    .container,
    .container-sm,
    .container-md,
    .container-lg,
    .container-xl {
        max-width: 1650px !important;
        /* overflow-x: hidden !important; */
    }
}

@media (max-width: 1200px) {
    body {
        font-size: 16px;
    }
}

@media (max-width: 1000px) {
    body {
        font-size: 15px;
    }
}

@media (max-width: 768px) {
    body {
        font-size: 14px;
    }
}

input[type='number']::-webkit-inner-spin-button,
input[type='number']::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type='number'] {
    -moz-appearance: textfield;
}

.cursor-pointer {
    cursor: pointer !important;
    background-color: #ff5800;
    width: 60px;
    /* height: 86px; */
    height: 100%;
    /* margin-right: -15px; */
}

.logo-new {
    height: 70px;
}

.router-link {
    color: black;
    display: flex;
    align-items: center;
    font-size: 20px;
}

.router-link span {
    padding-bottom: 5px;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
}

input:focus-visible {
    outline: none !important;
}

.form-control:focus {
    box-shadow: none;
}

.disabled {
    opacity: 0.3;
    pointer-events: none;
    cursor: pointer;
}

.cursor {
    cursor: pointer;
}

/* Change the white to any color */
input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
input:-webkit-autofill:active {
    box-shadow: 0 0 0 30px white inset !important;
}
@media (max-width: 575.98px) {
    .cursor-pointer {
        width: 60px;
        /* height: 45px; */
    }
    /* .container-fluid {
        padding-right: 0px;
        padding-left: 0px;
    } */
    .header .navbar {
        padding: 10px;
        height: 80px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/assets/styles/css/index.css"],"names":[],"mappings":"AAEA;IACI,SAAS;IACT,YAAY;IACZ,WAAW;IACX,sBAAsB;IACtB,mCAAmC;IACnC,mCAAmC;IACnC,2BAA2B;IAC3B,2BAA2B;IAC3B,6BAA6B;AACjC;AACA;;GAEG;AACH;IACI,UAAU;IACV,aAAa;AACjB;AACA;;;GAGG;AACH;IACI,2BAA2B;AAC/B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,8BAA8B;AAClC;AACA;IACI,0BAA0B;IAC1B,iCAAiC;AACrC;AACA;IACI,yBAAyB;AAC7B;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,sBAAsB;IACtB,mBAAmB;AACvB;AACA;IACI,sBAAsB;;EAExB;AACF;IACI;;;;;QAKI,4BAA4B;QAC5B,mCAAmC;IACvC;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;AACJ;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;IAC1B,yBAAyB;IACzB,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,yBAAyB;AAC7B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;IAKI,6CAA6C;AACjD;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,YAAY;IACZ,oBAAoB;IACpB,eAAe;AACnB;;AAEA;IACI,eAAe;AACnB;;AAEA,kCAAkC;AAClC;;;;IAKI,6CAA6C;AACjD;AACA;IACI;QACI,WAAW;QACX,kBAAkB;IACtB;IACA;;;OAGG;IACH;QACI,aAAa;QACb,YAAY;IAChB;AACJ","sourcesContent":["@import url('../fonts/stylesheet.css');\n\nbody {\n    margin: 0;\n    height: 100%;\n    color: #333;\n    background-color: #fff;\n    -webkit-font-smoothing: antialiased;\n    font-family: 'Gill Sans' !important;\n    font-weight: 500 !important;\n    line-height: 1.5 !important;\n    overflow-x: hidden !important;\n}\n/* .slick-slider {\n    overflow: hidden !important;\n} */\n.header .navbar {\n    padding: 0;\n    height: 100px;\n}\n/* .container-fluid {\n    padding-right: 60px;\n    padding-left: 60px;\n} */\n.MuiButton-root {\n    line-height: 22px!important;\n}\n.MuiInput-input {\n    font-weight: 500!important;\n}\n.MuiInput-root {\n    padding-bottom: 15px!important;\n}\n.MuiInputLabel-shrink {\n    transform: unset!important;\n    transform-origin: unset!important;\n}\nlabel + .MuiInput-formControl {\n    margin-top: 0px!important;\n}\n.MuiInputLabel-formControl {\n    transform: unset!important;\n}\n.MuiInputLabel-root {\n    transform-origin:unset;\n    top: 0px !important;\n}\n.slick-next {\n    right: -25px!important;\n    \n  }\n@media (min-width: 1200px) {\n    .container,\n    .container-sm,\n    .container-md,\n    .container-lg,\n    .container-xl {\n        max-width: 1650px !important;\n        /* overflow-x: hidden !important; */\n    }\n}\n\n@media (max-width: 1200px) {\n    body {\n        font-size: 16px;\n    }\n}\n\n@media (max-width: 1000px) {\n    body {\n        font-size: 15px;\n    }\n}\n\n@media (max-width: 768px) {\n    body {\n        font-size: 14px;\n    }\n}\n\ninput[type='number']::-webkit-inner-spin-button,\ninput[type='number']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type='number'] {\n    -moz-appearance: textfield;\n}\n\n.cursor-pointer {\n    cursor: pointer !important;\n    background-color: #ff5800;\n    width: 60px;\n    /* height: 86px; */\n    height: 100%;\n    /* margin-right: -15px; */\n}\n\n.logo-new {\n    height: 70px;\n}\n\n.router-link {\n    color: black;\n    display: flex;\n    align-items: center;\n    font-size: 20px;\n}\n\n.router-link span {\n    padding-bottom: 5px;\n}\n\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 30px white inset !important;\n    box-shadow: 0 0 0 30px white inset !important;\n}\n\ninput:focus-visible {\n    outline: none !important;\n}\n\n.form-control:focus {\n    box-shadow: none;\n}\n\n.disabled {\n    opacity: 0.3;\n    pointer-events: none;\n    cursor: pointer;\n}\n\n.cursor {\n    cursor: pointer;\n}\n\n/* Change the white to any color */\ninput:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ninput:-webkit-autofill:active {\n    -webkit-box-shadow: 0 0 0 30px white inset !important;\n    box-shadow: 0 0 0 30px white inset !important;\n}\n@media (max-width: 575.98px) {\n    .cursor-pointer {\n        width: 60px;\n        /* height: 45px; */\n    }\n    /* .container-fluid {\n        padding-right: 0px;\n        padding-left: 0px;\n    } */\n    .header .navbar {\n        padding: 10px;\n        height: 80px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
